import { clearToken } from 'utils/storeToken'
import allReducers from './allReducers'
import actions from './user/actions'

// https://stackoverflow.com/a/35641992
const rootReducer = history => (state, action) => {
  if (action.type === actions.RESET_APP) {
    clearToken()
    // not user related
    const { router, menu, settings } = state
    state = { router, menu, settings }
  }
  return allReducers(history)(state, action)
}

export default rootReducer
